import { Chip, Paper, Skeleton, Stack } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { useColumns } from '../hooks/useColumns';

export const LoadingSkeletons = () => {
  const { columns } = useColumns({
    extensions: [],
    isLoadingExtensions: false,
  });

  return (
    <Stack spacing={1} mt={0.5}>
      {Array.from({ length: 5 }, (_, index) => (
        <Stack
          key={index}
          flexDirection="row"
          alignItems="center"
          component={Paper}
          gap={6}
          px={2}
          sx={{
            borderRadius: borderRadius('m'),
            height: 44,
          }}
        >
          {columns.map(column => {
            if (column.field === 'status') {
              return (
                <Chip key={column.field} label={<Skeleton width="80px" />} />
              );
            }

            if (column.flex) {
              return (
                <Skeleton
                  key={column.field}
                  variant="text"
                  height={24}
                  sx={{
                    flex: column.flex,
                  }}
                />
              );
            }

            return (
              <Skeleton
                key={column.field}
                variant="text"
                height={24}
                sx={{ width: column.width ?? 100 }}
              />
            );
          })}
        </Stack>
      ))}
    </Stack>
  );
};
